import React from "react";
import type {
  DifyAPITestJobStatus,
  DifyAPITestRun,
} from "~/components/difyAPITest/difyAPITest.types";

/**
 * ジョブ状態ごとの表示定義
 */
const jobStatusMetaMap: Record<
  DifyAPITestJobStatus,
  {
    label: string;
    className: string;
  }
> = {
  queued: { label: "実行待機中", className: "dify-history-status-queued" },
  running: { label: "処理中", className: "dify-history-status-running" },
  completed: { label: "完了", className: "dify-history-status-completed" },
  error: { label: "エラー", className: "dify-history-status-error" },
  cancelled: { label: "キャンセル", className: "dify-history-status-cancelled" },
};

/**
 * 長い文字列を一覧表示用に短縮する
 * @param value 表示対象の文字列
 * @param maxLength 最大文字数
 * @return 短縮後の文字列
 */
const toPreviewText = (value: string, maxLength = 80) => {
  if (!value) {
    return "-";
  }

  if (value.length <= maxLength) {
    return value;
  }

  return `${value.slice(0, maxLength)}...`;
};

type DifyActiveRunSectionProps = {
  activeRun: DifyAPITestRun | null;
};

/**
 * 実行中ジョブの一覧を表示する
 * @return 画面要素
 */
const DifyActiveRunSection: React.FC<DifyActiveRunSectionProps> = ({ activeRun }) => {
  if (!activeRun) {
    return null;
  }

  return (
    <div className="dify-history-section">
      <h2 className="dify-history-title">現在の実行状況</h2>
      <div className="dify-history-table-wrapper">
        <table className="dify-history-table execution-status">
          <thead>
            <tr>
              <th>質問内容</th>
              <th>状態</th>
              <th>AI出力</th>
            </tr>
          </thead>
          <tbody>
            {activeRun.jobs.map((job) => {
              const statusMeta = jobStatusMetaMap[job.status];

              return (
                <tr key={job.jobId}>
                  <td>{job.question}</td>
                  <td className={`dify-history-status ${statusMeta.className}`}>
                    {statusMeta.label}
                  </td>
                  <td>{toPreviewText(job.aiOutput || job.errorMessage)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DifyActiveRunSection;
